<script setup lang="ts">
import { computed } from 'vue'
import { format } from 'date-fns'
import { enUS } from 'date-fns/locale/en-US'
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow'
import { mdiAlert, mdiCircleMedium } from '@mdi/js'
import { useNotificationStore } from '@/modules/notification/stores/notification.store'
import BadgeMenu from '@/shared/components/badge/BadgeMenu.vue'
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

const notificationStore = useNotificationStore()

const isUnRead = computed(() => notificationStore.alerts.some((alert) => alert.isUnread))
</script>

<template>
  <BadgeMenu
    v-if="notificationStore.alerts.length > 0"
    :badge="isUnRead"
    :title="$t('glossary.notification', 2)"
    :icon="mdiAlert"
    class="fill-warning"
  >
    <div v-for="alert in notificationStore.alerts">
      <div class="p-2">
        <div
          class="flex items-center cursor-default truncate p-1.5 hover:bg-gray-100"
          @mouseover="alert.isUnread = false"
        >
          <SvgIcon :path="alert.icon" class="fill-gray-700 h-10 w-10" />
          <div class="ms-1.5 w-full">
            <div class="flex justify-between items-center">
              <div>
                <div class="font-medium text-sm">{{ $t(alert.title) }}</div>
                <div v-if="alert.from && alert.to" class="font-light text-sm">
                  {{ $t('glossary.plannedDowntime') }}
                  <span class="lowercase">
                    {{ $t('common.from') }}
                    <span class="font-medium">{{ format(alert.from, 'p') }}</span>
                    {{ $t('common.to') }}
                    <span class="font-medium">{{ format(alert.to, 'p') }}</span>
                  </span>
                </div>
                <div v-if="alert.from" class="text-xs lowercase text-gray-600">
                  {{ formatDistanceToNow(alert.from, { locale: enUS }) }}
                  {{ $t('glossary.remaining') }}
                </div>
              </div>
              <div class="flex justify-between items-center">
                <SvgIcon
                  :path="mdiCircleMedium"
                  class="h-5 w-5"
                  :class="alert.isUnread ? 'fill-error' : 'fill-transparent'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BadgeMenu>
</template>
